import { t } from "@lingui/macro";
import {StorageKey} from "../../../../enums/StorageKey";
import OfficialReceiptSummary from "./OfficialReceiptSummary";

export default {
    storageKey: StorageKey.report_payment_voucher_summary,
    getReportLabel: () => t`Payment Voucher Summary`,
    required: [
        'date',
        'number',
        'base_amount',
    ],
    defaulto: [
        'type',
        'contact_name',
        'description',
    ],
    getColumns: OfficialReceiptSummary.getColumns,
};
